import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import cn from "classnames";
import VM from 'scratch-vm';

import styles from './lesson.css';
import Page from '../../components/page/page';
import bindAll from 'lodash.bindall';
import { getLesson } from '../../api/lesson';
import { setLesson, setLessonMembers, teachInitialState } from '../../reducers/teach';
import qs from "qs";
import event, { EVENTS } from '../../lib/event';
import PropTypes from "prop-types";
import PageContentMargin from "../../components/page-content-margin/page-content-margin";
import TaskGuide from "../../components/tasks/task-guide";
import TaskProgram from "../../components/tasks/task-program";
import TaskPlay from "../../components/tasks/task-play";
import TaskVideo from "../../components/tasks/task-video";
import { saveTaskRecord } from "../../api/task-record";
import { commentLesson, saveLessonRecord } from "../../api/lesson-record";
import DropdownMenu from "../../components/dropdown-menu/dropdown-menu";
import { getLessonMembers } from "../../api/lesson";
import { saveCourseRecord } from "../../api/course-record";
import { getClazz } from '../../api/clazz';
import Message from "../../components/message/message";
import ErrorModal from "../../components/show-error-modal/show-error-modal";
import Button from "../../../components/button/button";
import ModalManager from "../../components/modal/modal-manager";
import HomeworkCommentModal from "./homework-comment-modal";
import {
    LESSON_PROGRESS_STUDYING,
    LESSON_PROGRESS_HOMEWORKING,
    LESSON_PROGRESS_DONE,
    TASK_PROGRESS_DOING,
    TASK_PROGRESS_DONE,
    TASK_TYPE_GUIDE,
    TASK_TYPE_PROGRAM,
    TASK_TYPE_PLAY,
    TASK_TYPE_VIDEO, COURSE_MODE_CHALLENGE, COURSE_MODE_SCHEDULE, TRAIN_MODE, GUIDE_MODE, EXAMPLE_MODE
} from '../../lib/constant';
import LessonComplete from "../../components/tasks/lesson-complete";
import TaskComplete from "../../components/tasks/task-complete";
import { manualUpdateProject, reloadProject, saveProjectAsCopy, setProjectId } from "../../../reducers/project-state";
import TaskDescModal from "./task-desc-modal";
import TaskInitModal from './task-init-tipsModal';
import LoaderComponent from "../../../components/loader/loader";
import moment from "moment";
import changeMode from './change_mode.svg'
import { setTeachMode } from "../../reducers/teach";
import clickElement from "../../guide/actions/click-element";
import KeyBoard from './keyboard';
import {renderConfirmModal} from '../../components/confirm-modal/confirm-modal';

/**
 * 某一节课
 */
class LessonPage extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'getLesson',
            'showMessage',
            'onCurrentTaskRecordUpdate',
            'switchTask',
            'handleRestudyLesson',
            'handleExitLesson',
            'handleRestudyTask',
            'handleNextTask',
            'handleTaskSelect',
            'handleMemberSelect',
            'switchMember',
            'showCommentModal',
            'showTaskDesc',
            'currentTask',
            'taskComplete',
            'programTaskComplete',
            'playTaskComplete',
            'showTaskComplete',
            'showLessonComplete',
            'switchTeachMode',
            'getClazz',
            'nextStepStart',
            'showNextStepBtn',
            'hideNextStepBtn',
            'enableGuideSwitchBtn',
            'initTrainProjectTask',
            'initProgramTask',
            'showRightTopNav'
        ]);
        this.query = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
        this.state = {
            currentMemberIndex: this.query.index || 0,
            nextStepBtn: false,
            guideSwitchBtnDisable: false,
            showTopRight: false
        };

        if (this.props.lesson.id != this.query.id) {
            this.props.setLesson(teachInitialState.lesson);
        }
        if (this.props.lessonMembers.course_id != this.query.course_id || this.props.lessonMembers.clazz_id != this.query.clazz_id || this.props.lessonMembers.lesson_id != this.query.id) {
            this.props.setLessonMembers(teachInitialState.lessonMembers);
        }
    }

    async componentDidMount() {
        if (this.query.check) {
            let members = await getLessonMembers({
                clazz_id: this.query.clazz_id,
                course_id: this.query.course_id,
                id: this.query.id
            }, { quiet: !!this.props.lessonMembers.lesson_id });
            if (!members) members = [];
            this.props.setLessonMembers({
                course_id: this.query.course_id,
                clazz_id: this.query.clazz_id,
                lesson_id: this.query.id,
                data: members
            });
            if (members.length == 0) {
                Message.show(window.L('teach.class.noMember'));
                return;
            }
            if (this.query.student) {
                this.query.student_id = this.query.student;
            } else {
                this.query.student_id = members[0].id;
            }
        }
        this.getLesson();
        event.on('SHOW_NEXT_STEP_BTN', this.showNextStepBtn)
        event.on('HIDE_NEXT_STEP_BTN', this.hideNextStepBtn)
        // event.once('projectDidSave',()=>{
        //     debugger
        //     this.setState({guideSwitchBtnDisable: false})
        // })
        event.on('projectDidLoad', () => {
            setTimeout(this.enableGuideSwitchBtn, 1000);
        });
        event.on(EVENTS.PROJECT_LOADED_FINISH, this.showRightTopNav);
        event.on('CHAT_SHOW_TASK_MODAL', this.showTaskDesc);

        event.on('SHOW_ANSWER_MODE', () => {
            this.switchTeachMode(EXAMPLE_MODE)
        });
    }

    showRightTopNav() {
        this.setState({
            showTopRight: true
        })
    }

    showNextStepBtn() {
        this.setState({ nextStepBtn: true })
    }

    hideNextStepBtn() {
        this.setState({ nextStepBtn: false })
    }

    enableGuideSwitchBtn() {
        this.setState({ guideSwitchBtnDisable: false })
        if (this.enableGuideSwitchTimer) {
            clearTimeout(this.enableGuideSwitchTimer);
            this.enableGuideSwitchTimer = undefined;
        }
    }

    componentWillUnmount() {
        event.emit(EVENTS.CLEAR_COVER);
        event.removeListener('SHOW_NEXT_STEP_BTN', this.showNextStepBtn);
        event.removeListener('HIDE_NEXT_STEP_BTN', this.hideNextStepBtn);
        event.removeListener('projectDidSave', this.enableGuideSwitchBtn);
        event.removeListener('CHAT_SHOW_TASK_MODAL', this.showTaskDesc);
        event.removeListener('SHOW_ANSWER_MODE', () => this.switchTeachMode(EXAMPLE_MODE));
        event.removeListener(EVENTS.PROJECT_LOADED_FINISH, this.showRightTopNav);
        window.xiaoaoHide();
    }

    //TODO 这个方法没有用到，而且内部逻辑似乎有问题
    getClazz() {
        getClazz({ id: this.query.clazz_id }, { quiet: false }).then(res => {
            // this.joinCourse(res)
            let data = {
                course_id: Number(this.query.course_id),
                clazz_id: this.query.clazz_id,
                clazz_code: res.code
            };
            saveCourseRecord(data, { showLoading: window.L("teach.loading.submit") }).then(
                () => {
                    Message.show(window.L('teach.course.joinSuccess'));
                    // onJoinCourse();
                    this.props.reloadProject();
                },
                error => {
                    this.props.reloadProject();
                }
            );
        });
    }

    getLesson() {
        getLesson(this.query).then(async lesson => {
            if (this.query.check) { //作业批改模式
                if (this.query.landing_task !== undefined) { //指定了落地展示的任务
                    const landingTask = lesson.tasks[this.query.landing_task];
                    if (!landingTask) {
                        Message.show(window.L('teach.lesson.taskIndexNotExist'));
                    }else {
                        if (!landingTask.record) {
                            Message.show(window.L('teach.lesson.taskNotStarted'));
                        }else {
                            lesson.record.current_task = parseInt(this.query.landing_task);
                        }
                    }
                }else {
                    if (!lesson.record || lesson.record.progress < LESSON_PROGRESS_DONE) {
                        Message.show(window.L('teach.lesson.homeworkNotDone'))
                    }
                    if (lesson.homework_begin_task >= 0) {
                        const firstHomeworkTask = lesson.tasks[lesson.homework_begin_task];
                        if (!firstHomeworkTask.record) {
                            Message.show(window.L('teach.lesson.homeworkNotStarted'));
                        } else {
                            lesson.record.current_task = lesson.homework_begin_task; //切换到作业任务
                        }
                    }
                }
                this.props.setLesson(lesson);
            } else {
                this.props.setLesson(lesson);
                if (lesson.course_not_joined) { //尚未加入课程
                    ErrorModal.show('尚未报名加入当前班级的当前课程', this.props.history);
                    return;
                }
                if (lesson.record === undefined) {
                    if (this.query.clazz_id && this.query.course_id && (lesson.unlocked || lesson.unlocked === undefined && moment(lesson.time, "YYYY-MM-DD hh:mm") < moment())) {
                        lesson.record = {
                            'lesson_id': lesson.id,
                            'course_id': this.query.course_id,
                            'clazz_id': this.query.clazz_id,
                            'progress': LESSON_PROGRESS_STUDYING,
                            'current_task': 0,
                        };
                        lesson.record = await saveLessonRecord(lesson.record);
                    }
                } else {
                    if (lesson.record.progress < LESSON_PROGRESS_STUDYING) {
                        lesson.record.progress = LESSON_PROGRESS_STUDYING;
                        await saveLessonRecord(lesson.record);
                    }
                    //解决删减任务导致无法加载的问题
                    if (lesson.record.current_task >= lesson.tasks.length) {
                        lesson.record.current_task = lesson.tasks.length - 1;
                    }
                    this.switchTask(lesson.record.current_task);
                }
                //创建第一个任务的记录
                const firstTask = lesson.tasks[0];
                if (lesson.record && lesson.tasks && firstTask && !firstTask.record) {
                    firstTask.record = {
                        'lesson_record_id': lesson.record.id,
                        'progress': TASK_PROGRESS_DOING,
                        'task_id': firstTask.id
                    }
                    const res = await saveTaskRecord(firstTask.record);
                    firstTask.record.id = res.id;
                    firstTask.record.user_id = res.user_id;
                }
                this.forceUpdate();
            }

        }).catch(res => {
            ErrorModal.show(res.message, this.props.history)
        })
    }

    showMessage(msg) {
        return (<Page title={this.props.lesson.name} isModal={true}>
            <PageContentMargin>
                <h1>{msg}</h1>
            </PageContentMargin>
        </Page>);
    }

    /**
     * 切换任务
     * @param taskIndex
     */
    switchTask(taskIndex) {
        if (this.query.check) {
            //老师端切换任务的时候，重新载入lesson信息，这样学生最新的学习状态可以得到同步
            getLesson(this.query)
                .then(async lesson => {
                    this.props.setLesson(lesson);
                    this.doSwitchTask(taskIndex, lesson);
                });
        } else {
            this.doSwitchTask(taskIndex, this.props.lesson);
        }
    }

    doSwitchTask(taskIndex, lesson) {
        const task = lesson.tasks[taskIndex];
        // window.initState()
        //如果下一个任务记录不存在，创建新的任务记录
        if (task && task.record === undefined
            /* && (taskIndex == 0 || (lesson.tasks[taskIndex - 1].record && lesson.tasks[taskIndex - 1].record.progress >= TASK_PROGRESS_DONE))*/) {
            let newRecord = task.record = {
                'lesson_record_id': lesson.record.id,
                'progress': TASK_PROGRESS_DOING,
                'task_id': task.id
            };
            saveTaskRecord(newRecord, { quiet: true }).then(res => {
                newRecord.id = res.id;
                newRecord.user_id = res.user_id;
            });
        }
        if (taskIndex >= 0 && taskIndex < lesson.tasks.length && lesson.tasks[taskIndex].record !== undefined) {
            if (lesson.record.current_task != taskIndex) {
                lesson.record.current_task = taskIndex;
                this.forceUpdate();
                if (!this.query.check) saveLessonRecord({ id: lesson.record.id, current_task: lesson.record.current_task }, { quiet: false });
            }
        } else {
            console.error('taskIndex: ' + taskIndex + ' not created');
        }
        /* 切换到某个任务时，显示该任务完成状态
        if (task && task.record && task.record.progress == TASK_PROGRESS_DONE) {
            if (lesson.tasks.length > lesson.record.current_task + 1) {
                setTimeout(() => {
                    this.showTaskComplete();
                }, 800);
            } else {
                setTimeout(() => {
                    this.showLessonComplete();
                }, 800);
            }
        }

         */
    }

    // 初始化练习模式课程任务
    initTrainProjectTask() {
        ModalManager.open(TaskInitModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            onConfirm: () => {
                event.emit(EVENTS.INIT_TRAIN_PROJECT_TASK);
                ModalManager.closeAll();
            },
            type: 'task'
        });
    }

    // 初始化练习任务的项目
    initProgramTask() {
        ModalManager.open(TaskInitModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            onConfirm: () => {
                event.emit(EVENTS.INIT_PROGRAM_TASK);
                ModalManager.closeAll();
            },
            type: 'homework'
        });
    }

    /**
     * 更新任务状态
     */
    onCurrentTaskRecordUpdate() {
        const lesson = this.props.lesson;
        const taskRecord = lesson.tasks[lesson.record.current_task].record;
        saveTaskRecord(taskRecord, { quiet: true }).then(res => { taskRecord.id = res.id; }); //更新到服务器端
        //任务完成
        if (taskRecord.progress == TASK_PROGRESS_DONE) {
            if (lesson.homework_begin_task >= 0 && lesson.record.current_task + 1 >= lesson.homework_begin_task && lesson.record.progress < LESSON_PROGRESS_HOMEWORKING) {
                lesson.record.progress = LESSON_PROGRESS_HOMEWORKING;
            }
            if (lesson.tasks.length > lesson.record.current_task + 1) {
                //如果下一个任务记录不存在，创建新的任务记录
                const nextTask = lesson.tasks[lesson.record.current_task + 1];
                if (nextTask && nextTask.record === undefined) {
                    let newRecord = nextTask.record = {
                        'lesson_record_id': lesson.record.id,
                        'progress': TASK_PROGRESS_DOING,
                        'task_id': nextTask.id
                    };
                    this.forceUpdate();
                    saveTaskRecord(newRecord, { quiet: true }).then(res => {
                        newRecord.id = res.id;
                        newRecord.user_id = res.user_id;
                    });
                }
                this.showTaskComplete();//切换到下一个任务
                //this.switchTask(lesson.record.current_task + 1);
            } else { //课程完成
                //if (lesson.record.progress != LESSON_PROGRESS_DONE) { //只在第一次完成的时候显示
                this.showLessonComplete();
                lesson.record.progress = LESSON_PROGRESS_DONE;
                //}
            }
        }
        this.forceUpdate();
    }

    showTaskComplete() {
        const task = this.currentTask();
        const { lesson } = this.props;
        const isGuide = lesson.record && lesson.tasks[lesson.record.current_task]
        let taskName = null
        let taskIndex = null;
        lesson.tasks.map((item, index) => {
            if (isGuide && isGuide.id === item.id) {
                taskName = item.name
                taskIndex = index + 1
            }
        })
        if (!this.query.check) {
            ModalManager.open(TaskComplete, {
                closeAfterSubmit: true,
                onClose: () => { window.initState() },
                task,
                onNext: () => this.handleNextTask(),
                onRestudy: () => {
                    this.handleRestudyTask(task);
                },
                content: `任务${taskIndex}：${taskName}`
            });
            window.praise('你真棒！');
            this.playFinishMusic();
        }

    }

    showLessonComplete() {
        ModalManager.open(LessonComplete, {
            closeAfterSubmit: true,
            onClose: () => { window.initState() },
            onRestudy: () => {
                this.handleRestudyLesson();
            },
            onExit: () => this.handleExitLesson(),
        });
        window.praise('你真棒！');
        this.playFinishMusic();
    }

    playFinishMusic() {
        setTimeout(() => {
            const mp3 = 'https://oss.pkcode.cn/res/raw-assets/72/720d36bb-35d4-4acf-8955-d10e2fe9b19f.a3288.mp3'
            const aud = new Audio(mp3)
            aud.play()
        }, 500)
    }


    handleRestudyLesson() {
        const { lesson } = this.props;
        window.initState();
        lesson.tasks.map(task => {
            task.record.progress = TASK_PROGRESS_DOING;
            saveTaskRecord(task.record, { quiet: true });
        });
        if (this.props.lesson.record.current_task == 0) { //刷新当前任务
            this.handleRestudyTask(this.currentTask())
        } else {
            this.switchTask(0);
        }
    }

    handleExitLesson() {
        // window.initState();
        // this.props.history.go(-1);
        event.emit(EVENTS.NAV_BACK);
    }

    /**
     * 重学当前任务，除了标记状态，可能还需要重置当前任务界面
     * @param task
     */
    handleRestudyTask(task) {
        window.initState();
        task.record.progress = TASK_PROGRESS_DOING;

        //不同类型的任务可能需要一些个性化的额外处理，在Task中监听RESTUDY_TASK消息
        event.emit(EVENTS.RESTUDY_TASK);
        saveTaskRecord(task.record, { quiet: true });
        this.forceUpdate();
    }

    handleNextTask() {
        this.switchTask(this.props.lesson.record.current_task + 1);
    }

    handleTaskSelect(item, index) {
        this.switchTask(index);
        window.stepsRuntime.reset();
    }

    handleMemberSelect(item, index) {
        this.switchMember(index);
    }

    switchMember(index) {
        this.props.setLesson(teachInitialState.lesson);
        this.setState({ ...this.state, currentMemberIndex: index });
        this.query.student_id = this.props.lessonMembers.data[index].id;
        this.getLesson();
    }

    showCommentModal() {
        const record = this.props.lesson.record;
        let disabled = false
        if (!this.query.check && record.rate) {
            disabled = true
        }
        ModalManager.open(HomeworkCommentModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            initRate: record.rate,
            initComment: record.comment,
            disabled,
            onSubmit: (data) => {
                record.rate = data.rate;
                record.comment = data.comment;
                commentLesson(record, { showLoading: window.L('teach.loading.submit') }).then(() => {
                    Message.show(window.L('teach.homework.commentSuccess'));
                });
                this.forceUpdate();
            }
        });
    }

    currentTask(lesson) {
        lesson = lesson || this.props.lesson;
        if (lesson.tasks.length == 0)
            return null;
        else if (lesson.record)
            return lesson.tasks[lesson.record.current_task];
        else
            return lesson.tasks[0];
    }

    showTaskDesc(isHomework) {
        ModalManager.open(TaskDescModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            task: this.currentTask(),
            onRestudy: () => {
                event.emit(EVENTS.RESTUDY_TASK);
                ModalManager.closeAll();
            },
            onAnswer: () => {
                event.emit(EVENTS.SHOW_ANSWER_MODE);
                ModalManager.pop();
            },
            homework: isHomework
        });
    }


    /**
     * 使任务完成
     */
    taskComplete() {
        const task = this.currentTask();
        switch (task.type) {
            case TASK_TYPE_GUIDE:
                this.guideTaskComplete();
                break;
            case TASK_TYPE_PROGRAM:
                this.programTaskComplete();
                break;
            case TASK_TYPE_PLAY:
                this.playTaskComplete();
                break;
        }
        this.currentTask().record.progress = TASK_PROGRESS_DONE;
        this.onCurrentTaskRecordUpdate();
    }

    guideTaskComplete() {
        const task = this.currentTask();
        if (task && task.record && this.props.projectChanged) {
            if (task.record.modified_project_id == this.props.projectId) {
                this.props.saveProject();
            } else if (!task.record.modified_project_id) {
                this.props.saveProjectAsCopy();
            }
        }
    }

    programTaskComplete() {
        if (this.props.projectChanged) {
            const task = this.currentTask();
            if (task && task.record) {
                if (task.record.modified_project_id == this.props.projectId) {
                    this.props.saveProject();
                } else if (!task.record.modified_project_id) {
                    this.props.saveProjectAsCopy();
                }
            }
        }else {
            //提示：请先完成作业后，再提交
            renderConfirmModal({
                title: '请先完成作业后，再提交',
                closed: true,
                confirmText: '确定',
                onConfirm: () => {
                }
            });
        }
    }

    playTaskComplete() {

    }

    // 显示隐藏引导模式
    switchTeachMode(mode) {
        this.props.setTeachMode(mode);
        window.initState();
        if (mode === TRAIN_MODE) {
            setTimeout(() => {
                clickElement({
                    element: '[class*="lesson_completeTask"]',
                    noModal: true,
                    zIndex: 10000,
                    tips: '完成作品后，点击这里提交。'
                }).catch(e => { });
            }, 2000);
        } else {
            event.emit(EVENTS.CLEAR_COVER);
        }
        this.setState({ guideSwitchBtnDisable: true });
        this.enableGuideSwitchTimer = setTimeout(this.enableGuideSwitchBtn, 15000);
    }

    //下一步
    nextStepStart() {
        const { nextStepBtn } = this.state
        if (nextStepBtn) {
            stepsRuntime.goNext();
        }
    }


    render() {
        if (this.props.lesson.id != this.query.id) {
            return null;
        }
        const { lesson, lessonMembers, teachMode,isPhone,vm,keyboard,isFullScreen } = this.props;
        const { nextStepBtn, guideSwitchBtnDisable, showTopRight } = this.state;
        const isGuide = lesson.record && lesson.tasks[lesson.record.current_task]

        let fraction = null
        if (lesson.record && lesson.record.rate) {
            if (lesson.record.rate == '1') {
                fraction = '未通过'
            }
            if (lesson.record.rate == '3') {
                fraction = 'D'
            }
            if (lesson.record.rate == '6') {
                fraction = 'C'
            }
            if (lesson.record.rate == '8') {
                fraction = 'B'
            }
            if (lesson.record.rate == '10') {
                fraction = 'A'
            }
        }
        const membersMenuItems = lessonMembers.data.map((member, index) => ({
            id: member.id,
            content: `${index + 1}. ${member.name}`,
            available: true,
            score: member.rate
        }));

        let body = null;
        let task;
        let isShowCompleteBtn = false;
        if (lesson.record === undefined) { //课程尚未解锁
            let msg = window.L('teach.lesson.locked');
            if (lesson.clazzCourse) {
                switch (lesson.clazzCourse.mode) {
                    case COURSE_MODE_CHALLENGE:
                        msg = window.L('teach.lesson.challengeLockedMessage');
                        break;
                    case COURSE_MODE_SCHEDULE:
                        if (lesson.time) {
                            msg = window.L('teach.lesson.scheduleTimeIs') + lesson.time;
                        } else {
                            msg = window.L('teach.lesson.notScheduled');
                        }
                        break;
                }
            }
            body = this.showMessage(msg);
        } else if (lesson.record.current_task === -1) { //正在载入中
            body = <LoaderComponent message={window.L('teach.loading')} />;
        } else if (lesson.record.current_task == lesson.tasks.length) { //全部课程内容完成
            body =
                <Page isModal={true} title={lesson.name}>
                    <PageContentMargin>
                    </PageContentMargin>
                </Page>;
        } else {
            if (lesson.record.current_task >= lesson.tasks.length) { //可能是删除任务导致的指针溢出，恢复指向到第一个任务
                lesson.record.current_task = 0;
            }
            task = lesson.tasks[lesson.record.current_task];

            const taskList = lesson.tasks.map((item, index) => {
                let status = 1
                // 1.未解锁任务 2.当前任务 3.已完成任务 4.已解锁未完成
                if (!item.record) {
                    status = 1
                } else if (item.record.progress >= LESSON_PROGRESS_STUDYING) {
                    status = 3
                } else if (isGuide && isGuide.id === item.id) {
                    status = 2
                }
                const content = (lesson.homework_begin_task > -1 && index >= lesson.homework_begin_task ? (window.L("teach.lesson.homework") + '：') : (index + 1 + '. ')) + item.name
                return {
                    ...item,
                    content,
                    status,
                    id: item.id
                }
            })

            const homeworkBegin = lesson.homework_begin_task
            const lessonTasks = taskList
            const currentTaskId = !!task ? task.id : -1

            // 测试任务状态切换
            /*
            return (<div key={this.props.location.search}>
                <h1>{lesson.record.current_task + ": " + task.name}</h1>
                <button onClick={()=>{task.record.progress = TASK_PROGRESS_DONE; this.onCurrentTaskRecordUpdate();}}>模拟完成任务</button>
                <button onClick={()=>{this.props.history.push("/lesson?id=2&course_id=1&clazz_id=1")}}>第二课</button>
            </div>);
            */
            let taskContent = null;
            if (task.record) {
                switch (task.type) {
                    case TASK_TYPE_GUIDE:
                        taskContent = <TaskGuide
                            key={task.id + '_' + this.query.student_id}
                            currentTaskId={currentTaskId}
                            homeworkBeginTask={homeworkBegin}
                            lessonProgress={lessonTasks}
                            task={task}
                            isCheck={!!this.query.check}
                            onTaskUpdate={this.onCurrentTaskRecordUpdate}
                            currentLesson={lesson}
                            onSelect={this.handleTaskSelect}
                            onRate={this.showCommentModal}
                            currentMember={this.query.check && this.props.lessonMembers.data[this.state.currentMemberIndex].name}
                        />;
                        break;
                    case TASK_TYPE_PROGRAM:
                        taskContent = <TaskProgram
                            key={task.id + '_' + this.query.student_id}
                            task={task}
                            currentTaskId={currentTaskId}
                            homeworkBeginTask={homeworkBegin}
                            lessonProgress={lessonTasks}
                            isCheck={!!this.query.check}
                            currentLesson={lesson}
                            onTaskUpdate={this.onCurrentTaskRecordUpdate}
                            onSelect={this.handleTaskSelect}
                            onRate={this.showCommentModal}
                            currentMember={this.query.check && this.props.lessonMembers.data[this.state.currentMemberIndex].name}
                        />;
                        isShowCompleteBtn = true;
                        break;
                    case TASK_TYPE_PLAY:
                        taskContent = <TaskPlay key={task.id + '_' + this.query.student_id} task={task}
                            isCheck={!!this.query.check}
                            onTaskUpdate={this.onCurrentTaskRecordUpdate} />;
                        isShowCompleteBtn = true;
                        break;
                    case TASK_TYPE_VIDEO:
                        taskContent = <TaskVideo key={task.id + '_' + this.query.student_id} task={task}
                            isCheck={!!this.query.check}
                            onTaskUpdate={this.onCurrentTaskRecordUpdate} />;
                        break;
                    default:
                        taskContent = this.showMessage(window.L('teach.task.typeUndefined') + task.type);
                }
            }
            body = taskContent;
        }

        if (!!task && task.name) {
            document.title = task.name
        }

        return (
            <React.Fragment>
                {task && task.type !== TASK_TYPE_GUIDE &&
                    <div className={cn(styles.antRow, styles.topRight)} style={{ display: showTopRight ? "" : 'none' }}>
                        {!this.query.check && task && ( //只在非批改作业模式显示的内容
                            isShowCompleteBtn &&
                            <div style={{ display: 'flex' }}>
                                <div className={cn(styles.antCol)} onClick={this.taskComplete}>
                                    <Button className={`${styles.completeTask} ${styles.menuBarBtn}`}>
                                        {(task.type == TASK_TYPE_GUIDE || task.type == TASK_TYPE_PROGRAM) ? window.L('teach.task.submitProject') : window.L('teach.task.complete')}
                                    </Button>
                                </div>
                                <div className={cn(styles.antCol)} onClick={() => this.initProgramTask()}>
                                    <Button className={`${styles.completeTask} ${styles.menuBarBtn}`}>重做</Button>
                                </div>
                            </div>

                        )}

                        {!this.query.check && task && (
                            teachMode === TRAIN_MODE && isGuide.type === TASK_TYPE_GUIDE &&
                            <div style={{ display: 'flex' }}>
                                <div className={cn(styles.antCol)} onClick={this.taskComplete}>
                                    <Button className={`${styles.completeTask} ${styles.menuBarBtn}`}>
                                        {(task.type == TASK_TYPE_GUIDE || task.type == TASK_TYPE_PROGRAM) ? window.L('teach.task.submitProject') : window.L('teach.task.complete')}
                                    </Button>
                                </div>
                                <div className={cn(styles.antCol)} onClick={() => this.initTrainProjectTask()}>
                                    <Button className={`${styles.completeTask} ${styles.menuBarBtn}`}>重做</Button>
                                </div>
                            </div>

                        )}

                        {/* 下一步按钮 */}
                        {nextStepBtn ? (
                            <div className={cn(styles.antCol, styles.nextStepBtn)} onClick={this.nextStepStart}>
                                <Button className={styles.menuBarBtn}>下一步</Button>
                            </div>
                        ) : (null)}

                        {/* 标准例程 */}
                        {teachMode != EXAMPLE_MODE && task && task.type === TASK_TYPE_GUIDE ? (
                            <div className={cn(styles.antCol)}>
                                <Button className={styles.menuBarBtn}
                                    onClick={() => this.switchTeachMode(EXAMPLE_MODE)}
                                >{window.L("teach.task.exampleMode")}</Button>
                            </div>
                        ) : null}

                        {/* 引导按钮 */}
                        {isGuide && isGuide.type === TASK_TYPE_GUIDE && !this.query.check ? (
                            <div className={cn(styles.antCol)}>
                                <Button
                                    className={`${styles.menuBarBtn} ${styles.teachModeSwitchBtn}`}
                                    disabled={guideSwitchBtnDisable}
                                    onClick={() => this.switchTeachMode(teachMode === GUIDE_MODE ? TRAIN_MODE : teachMode === EXAMPLE_MODE ? TRAIN_MODE : GUIDE_MODE)}
                                >
                                    <div className={styles.btn}>
                                        <img src={changeMode} />
                                        {teachMode === GUIDE_MODE ? window.L('teach.task.guideEnd') : teachMode === EXAMPLE_MODE ? window.L('teach.task.guideEnd') : window.L('teach.task.guideStart')}
                                    </div>
                                </Button>
                            </div>
                        ) : (null)}

                        {/* 任务说明 */}
                        <div className={cn(styles.antCol)} onClick={() => this.showTaskDesc(1)}>
                            <Button className={styles.menuBarBtn}>
                                {window.L('teach.task.desc')}
                            </Button>
                        </div>

                        {/* 作业结果 */}
                        {/* {!this.query.check && (lesson.record && lesson.record.rate &&
                            <div className={cn(styles.antCol)} onClick={this.showCommentModal}>
                                <Button className={styles.menuBarBtn}>
                                    {fraction ? `评分${fraction}` : window.L('teach.lesson.unCommented')}
                                </Button>
                            </div>
                        )} */}

                        {this.query.check && ( //只在作业批改模式下显示的内容
                            <React.Fragment>
                                {/* <div className={cn(styles.antCol)} onClick={this.showCommentModal}>
                                    <Button className={styles.menuBarBtn}>
                                        {(!lesson.record || !lesson.record.rate) ? window.L('teach.lesson.unCommented') : window.L('teach.lesson.commented')}
                                    </Button>
                                </div> */}
                                {lessonMembers.data.length > 0 && (
                                    <React.Fragment>
                                        <div key="members" className={cn(styles.antCol, styles.dropdownWrapper)}>
                                            <DropdownMenu
                                                title={<div
                                                    className={styles.dropdownBtn}>{this.props.lessonMembers.data[this.state.currentMemberIndex].name}</div>}
                                                items={membersMenuItems}
                                                onSelect={this.handleMemberSelect}
                                                type="member"
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                        {/* <div key="task-nav" className={cn(styles.antCol, styles.dropdownWrapper)}>
                        <DropdownMenu
                            title={<div className={styles.dropdownBtn}>{window.L('teach.lesson.taskNav')}</div>}
                            items={taskNavMenuItems}
                            onSelect={this.handleTaskSelect}
                        />
                    </div> */}
                    </div>
                }
                {body}
                {
                    isPhone && keyboard && isFullScreen && <KeyBoard keyboardType={keyboard} vm={vm} />
                }
            </React.Fragment>
        )

    }

}

LessonPage.propTypes = {
    lesson: PropTypes.object,
    setLesson: PropTypes.func,
    location: PropTypes.object,
    lessonMembers: PropTypes.object,
    setLessonMembers: PropTypes.func,
    saveProject: PropTypes.func,
    reloadProject: PropTypes.func,
    teachMode: PropTypes.number,
    setTeachMode: PropTypes.func,
    projectId: PropTypes.string,
    saveProjectAsCopy: PropTypes.func,
    projectChanged: PropTypes.bool,
    vm: PropTypes.instanceOf(VM).isRequired,
    isFullScreen: PropTypes.bool
}

const mapStateToProps = state => ({
    lesson: state.teach.lesson,
    lessonMembers: state.teach.lessonMembers,
    teachMode: state.teach.teachMode ? state.teach.teachMode : GUIDE_MODE,
    projectId: state.scratchGui.projectState.projectId,
    projectChanged: state.scratchGui.projectChanged,
    isPhone: state.teach.isPhone,
    vm: state.scratchGui.vm,
    keyboard: state.teach.keyboard,
    isFullScreen: state.scratchGui.mode.isFullScreen
});


const mapDispatchToProps = dispatch => ({
    setLesson: lesson => dispatch(setLesson(lesson)),
    setLessonMembers: members => dispatch(setLessonMembers(members)),
    setProjectId: id => dispatch(setProjectId(id)),
    saveProject: () => dispatch(manualUpdateProject()),
    reloadProject: () => dispatch(reloadProject()),
    setTeachMode: mode => dispatch(setTeachMode(mode)),
    saveProjectAsCopy: () => dispatch(saveProjectAsCopy()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(LessonPage));
